import React from 'react';

const Footer = () => {
    return (
        <footer className="align-items-center justify-content-center text-center">
            <p>Inventory Management System</p>
        </footer>
    );
};

export default Footer;